var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[_c('md-icon',[_vm._v("person")])],1),_c('div',{staticClass:"user-info"},[_c('router-link',{attrs:{"to":{ name: 'Profil' }}},[_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }